import { ReactElement, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import BaseLayout from 'src/v3/components/base-layout'
import useSession from 'src/authentication/hooks/use-session'
import {
  fetchAssignments,
  fetchInProgressCourses,
  fetchSections,
  selectAssignmentsStatus,
  selectInProgressCoursesStatus,
  selectSectionsStatus,
} from './self-paced.slice'
import {
  classIDChanged,
  courseIDChanged,
  progressResetted,
} from '../classroom/classroom.slice'

interface Props {
  children: ReactElement | ReactElement[]
}

export default ({ children }: Props): ReactElement => {
  let { classID } = useParams()
  let { courseID } = useParams()
  let session = useSession()

  let sectionsStatus = useAppSelector(selectSectionsStatus)
  let inProgressCoursesStatus = useAppSelector(selectInProgressCoursesStatus)
  let assignmentsStatus = useAppSelector(selectAssignmentsStatus)
  let dispatch = useAppDispatch()

  let allowInLimited = true

  useEffect(() => {
    if (sectionsStatus === 'uninitialized') {
      dispatch(fetchSections())
    }
  }, [sectionsStatus])

  useEffect(() => {
    if (inProgressCoursesStatus === 'uninitialized') {
      dispatch(fetchInProgressCourses())
    }
  }, [inProgressCoursesStatus])

  useEffect(() => {
    if (assignmentsStatus === 'uninitialized') {
      dispatch(fetchAssignments())
    }
  }, [assignmentsStatus])

  // Make sure classroom resets when classID param changes in any self-paced route
  useEffect(() => {
    dispatch(progressResetted())
    dispatch(courseIDChanged(courseID ?? ''))
    dispatch(classIDChanged(classID ?? ''))
  }, [classID])

  return (
    <BaseLayout
      children={children}
      domain="self-paced"
      subMenuItems={[
        { name: 'Discover', route: '/', allowInLimited },
        {
          name: 'Continue Watching',
          route: '/continue-watching',
          allowInLimited,
        },
        { name: 'Assignments', route: '/assignments' },
        {
          name: 'Airway/Respiratory/Ventilation',
          route: '/section/71c5d72b-3d17-438d-a692-649779e3b020',
        },
        {
          name: 'Cardiovascular',
          route: '/section/e1a3c7bb-11ff-4af5-821f-8efbaae3b3d4',
        },
        {
          name: 'Trauma',
          route: '/section/1acfde29-b316-4ec7-8500-865f6251303c',
        },
        {
          name: 'Medical',
          route: '/section/a7ce1591-f5cc-445d-90a2-2a61de56a467',
        },
        {
          name: 'Pediatrics',
          route: '/section/de34454e-471e-4d25-9c1d-1cf0dfb60875',
        },
        {
          name: 'Operations',
          route: '/section/73e8b4ee-a1d3-4b77-95cc-5e263b2fc717',
        },
        {
          name: 'Critical Care',
          route: '/section/ca3d02f1-ad3f-4aa2-9e6d-6c4dc3d965f7',
        },
      ].filter(
        (item) =>
          !(item.name === 'Assignments' && !session?.linkedServices?.length),
      )}
    />
  )
}
